import { MetaReducer } from '@ngrx/store';

import { environment } from '../../environments/environment';

import { localStorageSyncReducer } from './localStorage.reducer';

export const metaReducers: MetaReducer<any>[] = !environment.production
  ? [localStorageSyncReducer]
  : [localStorageSyncReducer];
